import { render } from "./ServerView.vue?vue&type=template&id=257b5216&scoped=true"
import script from "./ServerView.vue?vue&type=script&lang=js"
export * from "./ServerView.vue?vue&type=script&lang=js"

import "./ServerView.vue?vue&type=style&index=0&id=257b5216&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-257b5216"]])

export default __exports__